import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AddressesText } from "../../Addresses/Addresses-types";
import { buildQuestionsMap, handleAddUpdateAddressFormSubmission, onAddressesUpdateError, onAddressesUpdateSuccess, } from "../../Addresses/addressesUtils";
import useToast from "../../hooks/useToast";
import { useAddUpdateAddressMutation } from "../../SWR/Addresses/useAddressMutations";
import { AddressFormInputs } from "./AddressFormInputs";
/**
 * * FOR NON-CONTEXT MODALS
 * This form is used in non-context modals.
 */
export const AddUpdateAddressForm = ({ deliveryQuestions, address, closeModal, formId, }) => {
    const toast = useToast();
    const { handleSubmit, reset, watch } = useFormContext();
    const { trigger: mutationTrigger } = useAddUpdateAddressMutation();
    const deliveryQuestionsMap = buildQuestionsMap(deliveryQuestions);
    /**
     * *ZIP CODE ENFORCEMENT
     * We do not currently allow the user to change the zip code on an existing address.
     * However, when delivery schedule remapping is implemented, we will need to track zip code changes
     * in order to determine if an address needs remapping.
     */
    const watchUpdateAddressZip = (address === null || address === void 0 ? void 0 : address.addressId) && watch("zip");
    /**
     * *UPDATE ZIP
     * Checks for zip changes and whether or not an address change requires remapping,
     * both of which are tied into remapping effort.
     */
    useEffect(() => {
        let mounted = true;
        const isBadZipCode = !(address === null || address === void 0 ? void 0 : address.addressId) || watchUpdateAddressZip !== address.zip;
        if (mounted && !!address && isBadZipCode) {
            reset();
            toast.push(AddressesText.SORRY_NO_CHANGE_ZIP, { variant: "error" });
        }
        return () => {
            mounted = false;
        };
    }, [watchUpdateAddressZip]);
    return (_jsx(_Fragment, { children: _jsx("form", Object.assign({ id: formId, onSubmit: (e) => {
                //preventDefault and stopPropagation are necessary here to stop the form submission propagating up to parent components
                e.preventDefault();
                handleSubmit(handleAddUpdateAddressFormSubmission(deliveryQuestionsMap, mutationTrigger, onAddressesUpdateSuccess(closeModal, toast, !!address, reset), onAddressesUpdateError(toast, reset)))();
                e.stopPropagation();
            }, noValidate: true, style: {
                flex: 1,
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
                overflow: "visible",
            } }, { children: _jsx(AddressFormInputs, { deliveryQuestions: deliveryQuestions, address: address, deliveryQuestionsMap: deliveryQuestionsMap }) })) }));
};
